var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"module-not-available-container"}),_c('div',{staticClass:"info-box"},[_c('i',{staticClass:"fal fa-5x",class:_vm.icon}),_c('h3',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }